import { useState, useContext } from 'react'
import Modal from '../Modal/Modal'
import { AuthContext } from '../../contexts/AuthContext'
import { fetchAPI } from '../../helpers/api'
import PopupMessage from '../PopupMessage/PopupMessage'

const DebtForm = () => {
    const [popup, setPopup] = useState({ message: '', type: '', shown: false })
    const { token } = useContext(AuthContext)
    const [formData, setFormData] = useState({
        taxid: '',
        paymentCode: '',
        description: '',
        amount: '',
        amountString: '',
        expirationDate: '',
        rfCode: '',
        debtType: 'None',
        surcharges: 0,
    })

    const handleChange = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const handleSubmit = async e => {
        e.preventDefault()

        const systemCode = `GVP-${formData.taxid}-${Date.now()}`
        const requestData = {
            taxid: formData.taxid,
            paymentCode: formData.paymentCode,
            systemCode,
            description: formData.description,
            amount: parseFloat(formData.amount),
            amountString: formData.amountString,
            expirationDate: new Date(formData.expirationDate), // Convert to Date object
            rfCode: formData.rfCode,
        }

        if (formData.debtType !== 'None') {
            requestData.debtType = formData.debtType
        }

        if (formData.surcharges > 0) {
            requestData.surcharges = parseFloat(formData.surcharges)
        }

        // Conditionally add fields based on debtType
        if (formData.debtType === 'UNCONFIRMED') {
            requestData.settlements = formData.settlements || ''
            requestData.settlementCode = formData.settlementCode || ''
            requestData.DueInstallmentNumber =
                formData.DueInstallmentNumber || ''
        } else if (formData.debtType === 'CONFIRMED') {
            requestData.moneyList = formData.moneyList || ''
            requestData.acceptedAmount = formData.acceptedAmount
                ? parseFloat(formData.acceptedAmount)
                : undefined
        }

        try {
            const res = await fetchAPI(
                `${process.env.REACT_APP_API_URL}/debts`,
                {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${token.access_token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestData),
                }
            )
            const success = res.success
            if (success) {
                setPopup(values => ({
                    ...values,
                    shown: true,
                    message: (
                        <>
                            <div className="flex flex-col">
                                <p>Η οφειλή προστέθηκε επιτυχώς</p>
                            </div>
                        </>
                    ),
                    type: 'success',
                }))
                setTimeout(() => {
                    window.location.reload()
                }, 4000)
            } else {
                setPopup(values => ({
                    ...values,
                    shown: true,
                    message: (
                        <>
                            <>
                                <p>Κάτι πήγε στραβά! </p>
                                <p>Παρακαλώ προσπαθήστε ξανά.</p>
                            </>
                        </>
                    ),
                    type: 'error',
                }))
            }
        } catch (error) {
            setPopup(values => ({
                ...values,
                shown: true,
                message: (
                    <>
                        <>
                            <p>Κάτι πήγε στραβά! </p>
                            <p>Παρακαλώ προσπαθήστε ξανά.</p>
                        </>
                    </>
                ),
                type: 'error',
            }))

            console.error('Error during debt creation:', error)
        }
    }

    return (
        <>
            {popup.shown && (
                <PopupMessage
                    message={popup.message}
                    type={popup.type}
                    closePopUp={() =>
                        setPopup(values => ({ ...values, shown: false }))
                    }
                    showCloseButton={true}
                />
            )}
            <Modal classes="w-1/2 self-center justify-self-center my-8">
                <form
                    onSubmit={handleSubmit}
                    className="max-w-[80%] mx-auto p-8 bg-white"
                >
                    <h2 className="text-3xl my-8 text-center">
                        Πληρωμή Οφειλής
                    </h2>

                    <label className="block mb-2">ΑΦΜ Οφειλέτη</label>
                    <input
                        type="text"
                        name="taxid"
                        value={formData.taxid}
                        onChange={handleChange}
                        className="w-full border-b"
                        required
                    />

                    <label className="block my-4">Κωδικός Οφειλής:</label>
                    <input
                        type="text"
                        name="paymentCode"
                        value={formData.paymentCode}
                        onChange={handleChange}
                        className="w-full border-b"
                        required
                    />

                    <label className="block my-4">Αιτιολογία:</label>
                    <input
                        type="text"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        className="w-full border-b"
                        required
                    />

                    <label className="block my-4">Ποσό (€):</label>
                    <input
                        type="number"
                        name="amount"
                        value={formData.amount}
                        onChange={handleChange}
                        className="w-full border-b"
                        required
                    />

                    <label className="block my-4">Ολογράφως:</label>
                    <input
                        type="text"
                        name="amountString"
                        value={formData.amountString}
                        onChange={handleChange}
                        className="w-full border-b"
                    />

                    <label className="block my-4">Ημερομηνία Λήξης:</label>
                    <input
                        type="datetime-local"
                        name="expirationDate"
                        value={formData.expirationDate}
                        onChange={handleChange}
                        className="w-full border-b"
                        required
                    />

                    <label className="block my-4">RF Code:</label>
                    <input
                        type="text"
                        name="rfCode"
                        value={formData.rfCode}
                        onChange={handleChange}
                        className="w-full border-b"
                    />

                    <label className="block my-4">Τύπος Οφειλής:</label>
                    <select
                        name="debtType"
                        value={formData.debtType}
                        onChange={handleChange}
                        className="w-full p-2 border rounded"
                    >
                        <option value="None">Απλή οφειλή</option>
                        <option value="CONFIRMED">Επιβεβαιωμένη</option>
                        <option value="UNCONFIRMED">Μη Επιβεβαιωμένη</option>
                    </select>

                    {formData.debtType === 'UNCONFIRMED' && (
                        <>
                            <label className="block my-4">Διακανονισμός:</label>
                            <input
                                type="text"
                                name="settlements"
                                value={formData.settlements}
                                onChange={handleChange}
                                className="w-full border-b"
                            />

                            <label className="block my-4">Προσαυξήσεις</label>
                            <input
                                type="number"
                                name="surcharges"
                                value={formData.surcharges}
                                onChange={handleChange}
                                className="w-full border-b"
                            />

                            <label className="block my-4">
                                Κωδικός Διακανονισμού:
                            </label>
                            <input
                                type="text"
                                name="settlementCode"
                                value={formData.settlementCode}
                                onChange={handleChange}
                                className="w-full border-b"
                            />

                            <label className="block my-4">
                                Αριθμός Δόσης Οφειλής:
                            </label>
                            <input
                                type="text"
                                name="DueInstallmentNumber"
                                value={formData.DueInstallmentNumber}
                                onChange={handleChange}
                                className="w-full border-b"
                            />
                        </>
                    )}
                    {formData.debtType === 'CONFIRMED' && (
                        <>
                            <label className="block my-4">
                                Χρηματικός Κατάλογος
                            </label>
                            <input
                                type="text"
                                name="moneyList"
                                value={formData.moneyList}
                                onChange={handleChange}
                                className="w-full border-b"
                            />

                            <label className="block my-4">Προσαυξήσεις</label>
                            <input
                                type="number"
                                name="surcharges"
                                value={formData.surcharges}
                                onChange={handleChange}
                                className="w-full border-b"
                            />

                            <label className="block my-4">
                                Αποδεκτό Ποσό (€):
                            </label>
                            <input
                                type="number"
                                name="acceptedAmount"
                                value={formData.acceptedAmount}
                                onChange={handleChange}
                                className="w-full border-b"
                            />
                        </>
                    )}

                    <button
                        type="submit"
                        className="my-4 w-full bg-black text-white p-2 rounded"
                    >
                        Προσθήκη
                    </button>
                </form>
            </Modal>
        </>
    )
}

export default DebtForm
